import { render, staticRenderFns } from "./CRRadioButton.vue?vue&type=template&id=4ff5e8c8&scoped=true"
import script from "./CRRadioButton.vue?vue&type=script&lang=js"
export * from "./CRRadioButton.vue?vue&type=script&lang=js"
import style0 from "./CRRadioButton.vue?vue&type=style&index=0&id=4ff5e8c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff5e8c8",
  null
  
)

export default component.exports